import { AWS_IMAGE_BASE_URL, AWS_IMAGE_FOLDERS } from '@api/axios';

export function getFullImagePath(imageName) {
  if (!!!imageName) return;
  return AWS_IMAGE_BASE_URL + AWS_IMAGE_FOLDERS.lg + '/' + imageName;
}